import { getModel } from '../../model/registry'
import { useCallback } from "react";
import styled from "styled-components";
import addHeaders from "../../utils/addHeader";
import ConnectControl from "../select/ConnectControl";

// Setup Use of Data

//This allows to return the data read from the select entities
import generateSetValueObject from "../select/generateSetValueObject";

//Setting up the Wrapper
const DataListContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    position: relative;
`

//Select takes an entity like 'unit' a value like {name:'meter',id:'1'} a setter and options object.
const DataList = ({ entity, valueName, valueMap, setValue, options = {}, isRed, modalTitle, modalOpacity, placeholder, testId }) => {
    if (!getModel('dataListData')[entity]) {
        console.warn(`DataList: unknown entity "${entity}"`);
    }

    const data = getModel('dataListData')[entity]

    const result = addHeaders(data, options.withHeaders)

    //Return Data to Form
    const returnData = useCallback((data) => {
        const result = generateSetValueObject(data, valueMap);
        setValue(result);
    }, [valueMap, setValue])

    return (
        <DataListContainer>
            <ConnectControl
                valueName={valueName}
                data={result}
                placeholder={placeholder}
                onSelect={selection => returnData(selection)}
                entity={entity}
                modalTitle={modalTitle}
                modalOpacity={modalOpacity}
                options={options}
                isRed={isRed}
                $alwaysOn={true}
                testId={testId}
            />
        </DataListContainer>
    );
};

export default DataList;
